<app-login-template title="Ügyvédi Partner Belépés"></app-login-template>
